/*
 Created by CHT 2019/10/10 17:09
 */

import DateInput from "./DateInput"
import {
  DATA_TYPE__ARRAY, DATE_TYPE__DAY, DEFAULT_VALUE__CUSTOM,
  FORM_ITEM__DATE_RANGE
} from "../types"
import {defaultValueInit, formatDate} from "../utils"

class DateRange extends DateInput {
  constructor() {
    super()
    this.value = []
  }

  get title() {
    return this.fieldTitle || DateRange._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

DateRange._title = '起止时间'
DateRange.type = FORM_ITEM__DATE_RANGE
DateRange.use = true
DateRange.icon = 'iconfont icon-zuoyeshijianduan'

DateRange.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, null),
    label: '自定义'
  }
]
DateRange.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '大于等于',
    method: 'gte'
  },
  {
    name: '小于等于',
    method: 'lte'
  },
  {
    name: '选择范围',
    method: 'range'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
DateRange.prototype.type = DateRange.type
DateRange.prototype.dataType = DATA_TYPE__ARRAY
DateRange.prototype.valueToString = function (value) {
  value = value || this.value
  if (!value || !value.length) {
    return ''
  }
  let format = 'yyyy-MM-dd HH:mm:ss'
  if (this.dateType === DATE_TYPE__DAY) {
    format = 'yyyy-MM-dd'
  }
  return formatDate(value[0])(format) + '~' + formatDate(value[1])(format)
}
DateRange.prototype.setValue = function (val) {
  this.value = val || []
}
export default DateRange
